import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Container } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { LanguageProvider } from '../../../core/language-provider';
import ModalEntityCompiler from '../../../components/Modals/ModalEntityCompiler';



export default function SVTH_gyv_mpm({ data, entity = null}) {

    const navigate = useNavigate();

    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    function closeModalCompiler() {
        setModalCompilerInitData(null)
    }

    useEffect(() => {
        if(modalCompilerInitData !== null) {
            setModalCompilerStatus(true)
        }
        else {
            setModalCompilerStatus(false)
        }
    }, [modalCompilerInitData]);

    async function modalCompilerSave(el) {
        console.log(el)
        var response = await DataManager.insertItem('manufacturing_process_model', el);
        if(response.success === 1) {
            navigate(0);
        }
        else {
            console.warn(response)
        }
        setModalCompilerInitData(null)
    }

    function create() {
        setModalCompilerInitData({})
    }



    return (
        <>
            <Container fluid className='mt-3'>
                <Button onClick={create} variant='outline-success'>Inserisci nuova distinta</Button>
            </Container>

            {modalCompilerStatus !== false ? (
                <ModalEntityCompiler entity={'manufacturing_process_model'} initData={modalCompilerInitData} close={closeModalCompiler} status={modalCompilerStatus} confirmCallback={modalCompilerSave} />
            ) : (
                <></>
            )}
        </>
    )
};